import {
    AUTHENTICATION_LOGIN_REQUEST,
    AUTHENTICATION_LOGIN_RESPONSE,
    AUTHENTICATION_LOGIN_UNAUTHORIZED,
    AUTHENTICATION_LOGIN_ERROR,
    UNAUTHENTICATED,
    AUTHENTICATION_FORGOT_RESPONSE,
    AUTHENTICATION_FORGOT_REQUEST,
    AUTHENTICATION_TOGGLE_FORM,
    AUTHENTICATION_TOKEN_REQUEST,
    AUTHENTICATION_TOKEN_RESPONSE,
    SET_HAS_BEEN_ACTIVE,
    TIMER_REFRESH,
} from "./action-types"

export const loginRequest = (username, password) => ({
    type: AUTHENTICATION_LOGIN_REQUEST,
    username,
    password,
})

export const tokenRequest = (token) => ({
    type: AUTHENTICATION_TOKEN_REQUEST,
    token,
})

export const loginResponse = (loginResponse) => ({
    ...loginResponse,
    type: AUTHENTICATION_LOGIN_RESPONSE,
})

export const tokenResponse = (tokenResponse) => ({
    ...tokenResponse,
    type: AUTHENTICATION_TOKEN_RESPONSE,
})

export const unauthenticated = (isLogout = false) => ({
    type: UNAUTHENTICATED,
    isLogout,
})

export const loginError = (error) => ({
    type: AUTHENTICATION_LOGIN_ERROR,
    error,
})

export const loginUnauthorized = (error) => ({
    type: AUTHENTICATION_LOGIN_UNAUTHORIZED,
    error,
})

export const forgotRequest = (email) => ({
    type: AUTHENTICATION_FORGOT_REQUEST,
    email,
})

export const forgotResponse = (forgotResponse) => ({
    ...forgotResponse,
    type: AUTHENTICATION_FORGOT_RESPONSE,
})

export const toggleAuthForm = (formName) => {
    return {
        type: AUTHENTICATION_TOGGLE_FORM,
        formName,
    }
}

export const setHasBeenActive = (hasBeenActive) => {
    return {
        type: SET_HAS_BEEN_ACTIVE,
        hasBeenActive,
    }
}

export const timerRefresh = () => ({ type: TIMER_REFRESH })
